import { gameState } from "appworks/model/game-state";
import { builderManager } from "appworks/server/builders/builder-manager";
import { Contract } from "appworks/utils/contracts/contract";
import { Sequence } from "appworks/utils/contracts/sequence";
import { PartnerConnectManager } from "partner-connect/partner-connect-manager";
import { Init } from "slotworks/state-machine/standard/states/init";

export class PartnerConnectInit extends Init {

    public onEnter() {
        new Sequence([
            () => Contract.wrapPromise(PartnerConnectManager.getEmitters()?.gameLoadingEnded()),
            () => Contract.wrap(() => super.onEnter())
        ]).execute();
    }

    public onExit() {
        // Do nothing
    }

    public complete() {
        PartnerConnectManager.gameReady().then(() => {
            super.complete();
        });
        PartnerConnectManager.setInitialGrid();
        builderManager.buildRecord(gameState.getCurrentGame(), {}, PartnerConnectManager.getConfig());
    }
}
